export const dnldRCScdrReports = (builder) => ({
    dnldRCScdrReports: builder.mutation({
        query: ({ user_type_id, search, startDate, endDate, status, limit, page, loggedin_user_id }) => {
            return {
                url:  process.env.REACT_APP_RCS_API_PORT +'/download_rcs_cdrs',
                method: 'GET',
                params: { user_type_id, search, startDate, endDate, status, limit, page, loggedin_user_id },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});